export default {
  state: {
    newsletter_type: {},
    newsletter_type_subscribers: [],
    subscribers: [],
    subscriptions: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/NewsletterTypeSubscribersStore.js